import { ADMIN_CONTRACT_LIST } from './index';
import { Action } from '../action';

export class AdminContractListInitAction implements Action {
	readonly type = ADMIN_CONTRACT_LIST.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminContractListDestroyAction implements Action {
	readonly type = ADMIN_CONTRACT_LIST.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminContractListSyncAction implements Action {
	readonly type = ADMIN_CONTRACT_LIST.SYNC;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminContractListSyncSuccessAction implements Action {
	readonly type = ADMIN_CONTRACT_LIST.SYNC_SUCCESS;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminContractListSyncFailureAction implements Action {
	readonly type = ADMIN_CONTRACT_LIST.SYNC_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminContractListHydrateAction implements Action {
	readonly type = ADMIN_CONTRACT_LIST.HYDRATE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminContractListHydrateSuccessAction implements Action {
	readonly type = ADMIN_CONTRACT_LIST.HYDRATE_SUCCESS;
	constructor(
		public payload: any[],
		public correlationId?: number
	) {}
}

export class AdminContractListHydrateFailureAction implements Action {
	readonly type = ADMIN_CONTRACT_LIST.HYDRATE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}
